// Convert clock in seconds to min:sec, or x.y if under 1 minute.
export const formatClock = (clock: number) => {
	if (clock <= 59.9) {
		const centiSecondsRounded = Math.ceil(clock * 10);
		const remainingSeconds = Math.floor(centiSecondsRounded / 10);
		const remainingCentiSeconds = centiSecondsRounded % 10;
		return `${remainingSeconds}.${remainingCentiSeconds}`;
	} else {
		const secondsRounded = Math.ceil(clock);
		const minutes = Math.floor(secondsRounded / 60);
		const remainingSeconds = secondsRounded % 60;
		const formattedSeconds =
			remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
		return `${minutes}:${formattedSeconds}`;
	}
};
